import { THEMES, ThemeConfig, ThemeName } from '@/theme/themes';
import useStore from '@/store';

/**
 * Read the active theme name. Components rarely need this directly — they read
 * `useThemeConfig()` for assets/typography/layout and just use the existing
 * palette classes (`bg-primary-blue-3`, `text-primary-yellow-3`, …) for colors,
 * which re-skin per theme on their own (see `tailwind/theme-tokens.cjs`). The
 * name is mainly for syncing the `data-theme` attribute (see `useApplyTheme`).
 */
export const useThemeName = (): ThemeName => useStore((state) => state.currentTheme);

/**
 * The single entry point for theme-aware presentation: assets, bundled
 * typography classes, geometry, and structural layout flags. Defaults to the
 * `default` theme, so existing screens stay backward compatible.
 */
export const useThemeConfig = (): ThemeConfig => THEMES[useThemeName()];
